// extracted by mini-css-extract-plugin
export var adjacentSlide = "_sp-9";
export var arrowButtonContainer = "_sp-5";
export var arrowButtonIcon = "_sp-6";
export var carouselArrowButton = "_sp-2";
export var carouselElementContainer = "_sp-1";
export var currentSlide = "_sp-8";
export var left = "_sp-3";
export var otherSlide = "_sp-a";
export var productCarouselContainer = "_sp-0";
export var right = "_sp-4";
export var sliderOverflow = "_sp-7";